import React, { useCallback } from 'react';
import { InformationBox } from '@app/core';
import { Account, useLoginWithEmailValidationCode } from '@app/api';
import { CodeVerificationContent } from './CodeVerificationContent';
import { useTranslation } from 'react-i18next';

interface Props {
  onSuccess?: (account: Account) => any;
  hideTitle?: boolean;
  displayed?: boolean;
  text?: string;
  email?: string;
  participantId?: string;
  onNoAccountForParticipant?: () => boolean | undefined | void;
}

export const LoginViaCodeContent = ({
  onSuccess,
  email,
  text,
  participantId,
  displayed,
  onNoAccountForParticipant,
}: Props) => {
  const { t } = useTranslation('common');
  const {
    mutateAsync: login,
    isLoading,
    error,
  } = useLoginWithEmailValidationCode();

  const submit = useCallback(
    async (accountId: string, code: string) => {
      const account = await login({
        accountId,
        code,
      });
      onSuccess && onSuccess(account);
    },
    [onSuccess, login],
  );

  if (!email && !participantId) {
    return <InformationBox title={t('toast.genericError')} variant="danger" />;
  }

  return (
    <CodeVerificationContent
      hideTitle
      error={error}
      verifiedMethod={submit}
      displayed={displayed}
      participantId={participantId}
      text={text}
      email={email}
      isLoading={isLoading}
      onNoAccountForParticipant={onNoAccountForParticipant}
    />
  );
};
